// src/pages/MentionsLegales.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/MentionsLegales.css';

const MentionsLegales = () => {
    return (
        <div className="mentions-legales-page">
            <h1>
                <Link to="/mentions-legales">Mentions Légales</Link>
            </h1>

            <h2>1. Présentation du Site</h2>
            <p>
                Le site Naninan est une plateforme dédiée à la promotion des événements cinématographiques, à l’information relative aux dates et lieux de sortie des films et à la collecte d’avis et commentaires des utilisateurs sur les films. Il s’adresse à tous les passionnés de cinéma désireux de découvrir et partager leur expérience autour de la filmographie.
            </p>

            <h2>2. Éditeur du Site</h2>
            <p>
                Le site Naninan est édité par l’entreprise Africa Data Entry.
            </p>
            <p><strong>Nom ou Raison Sociale :</strong> Africa Data Entry</p>
            <p><strong>Forme Juridique :</strong> Société à Responsabilité Limitée (SARL)</p>
            <p><strong>Siège Social :</strong> 17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO</p>
            <p>
                <strong>Téléphone :</strong> <a href="tel:+22604443988">+226 04 44 39 88</a>
            </p>
            <p>
                <strong>Adresse e-mail :</strong> <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a>
            </p>
            <p><strong>Numéro du RCCM :</strong> BF-OUA-01-2024-B12-14600</p>

            <h2>3. Directeur de la Publication</h2>
            <p>
                La publication du site est assurée par :
                <br/><strong>Nom et Prénom :</strong> Djibril PAMOUSSO
                <br/><strong>Fonction :</strong> Principal Gérant Africa Data Entry
            </p>

            <h2>4. Hébergeur</h2>
            <p>
                Le site Naninan est hébergé par :
                <br/><strong>Nom de l’Hébergeur :</strong> LWS
                <br/><strong>Adresse de l’Hébergeur :</strong> 10 rue Penthièvre 75008 Paris (FRANCE)
                <br/><strong>Téléphone :</strong> <a href="tel:+33177623003">+33 177 62 30 03</a>
                <br/><strong>Site web :</strong> <a href="https://www.lws.fr" target="_blank" rel="noopener noreferrer">www.lws.fr</a>
            </p>

            <h2>5. Propriété Intellectuelle</h2>
            <p>
                L’ensemble des contenus présents sur le site Naninan (textes, images, vidéos, graphismes, logos, icônes, etc.) est la propriété exclusive de Africa Data Entry ou de tiers ayant autorisé leur utilisation. Toute reproduction, représentation, modification ou utilisation, totale ou partielle, sans autorisation préalable écrite est strictement interdite et constituerait une contrefaçon sanctionnée par la législation en vigueur.
            </p>

            <h2>6. Responsabilités</h2>
            <h3>Contenus et Informations</h3>
            <p>
                L’équipe de Africa Data Entry s’efforce de fournir des informations fiables et mises à jour concernant les événements cinématographiques et les sorties de films. Toutefois, Africa Data Entry ne peut garantir l’exactitude, l’exhaustivité ou la mise à jour permanente des informations diffusées sur le site. L’utilisateur reconnaît utiliser ces informations sous sa seule responsabilité.
            </p>
            <h3>Avis des Utilisateurs</h3>
            <p>
                Les avis et commentaires publiés par les utilisateurs le sont sous leur responsabilité. Africa Data Entry se réserve le droit de modérer ou de supprimer tout contenu jugé inapproprié ou en violation avec la législation applicable.
            </p>

            <h2>7. Collecte et Traitement des Données Personnelles</h2>
            <p>
                Dans le cadre de la navigation sur le site et de la publication d’avis, des données personnelles peuvent être collectées via des formulaires. Ces données sont utilisées pour la gestion des commentaires et avis, l’information des utilisateurs et l’amélioration des services proposés, conformément à la politique de confidentialité.
            </p>

            <h2>8. Utilisation des Cookies</h2>
            <p>
                Le site Naninan utilise des cookies pour faciliter la navigation, analyser l’audience et personnaliser l’expérience utilisateur. L’utilisateur peut configurer son navigateur pour refuser les cookies, ce qui pourrait limiter certaines fonctionnalités du site. Pour plus d’informations, consultez notre politique relative aux cookies.
            </p>

            <h2>9. Droit Applicable et Juridiction</h2>
            <p>
                Les présentes mentions légales sont régies par le droit en vigueur dans le pays de domiciliation de Africa Data Entry. En cas de litige relatif à l’utilisation du site, les tribunaux de Ouagadougou seront seuls compétents, sous réserve des règles d’ordre public applicables.
            </p>

            <h2>10. Mise à Jour des Mentions Légales</h2>
            <p>
                Africa Data Entry se réserve le droit de modifier à tout moment les présentes mentions légales afin de les adapter aux évolutions législatives, techniques ou aux modifications de la présentation du site. Il est conseillé aux utilisateurs de consulter régulièrement cette page.
            </p>
        </div>
    );
};

export default MentionsLegales;
